<template>
  <div class="provider-list-page">
    <div class="loading-placeholder" v-if="loading">
      <loading-symbol />
    </div>
    <no-data-message v-else-if="noDataFound" />
    <provider-list-view v-else :providers="providers" />
  </div>
</template>

<style scoped>
  .loading-placeholder {
    margin-top: 200px;
    height: 450px;
  }
</style>

<script>
import { mapState, mapActions } from 'vuex';
import ProviderListView from '@/components/provider/ProviderListView.vue';
import LoadingSymbol from '@/components/LoadingSymbol.vue';
import NoDataMessage from '@/components/NoDataMessage.vue';

export default {
  name: 'provider-list',
  computed: {
    noDataFound() {
      return this.providers.length === 0;
    },
    fetchParams() {
      return {
        ...this.filterParams,
        offset: this.providers ? this.providers.length : 0,
        category: this.currentCategory,
      };
    },
    ...mapState({
      providers: (state) => state.provider.list,
      countries: (state) => state.country.countries,
      loading: (state) => state.provider.list === undefined
          || state.category.list === undefined || state.country.list === undefined,
      filterParams: (state) => state.filter.form,
      currentCategory: (state) => state.category.active,
    }),
  },
  components: {
    ProviderListView,
    LoadingSymbol,
    NoDataMessage,
  },
  data() {
    return {
      scrollEnabled: true,
      scrollTimeout: undefined,
      controlOffset: 0,
    };
  },
  methods: {
    disableScroll() {
      this.scrollEnabled = false;
    },
    enableScroll() {
      this.scrollTimeout = setTimeout(() => {
        this.scrollEnabled = true;
      }, 500);
    },
    ...mapActions({
      fetchProviders: 'fetchProviders',
      addProviders: 'addProviders',
      fetchCountries: 'fetchCountries',
    }),
  },
  created() {
    this.fetchProviders(this.fetchParams);
    this.fetchCountries();
  },
  updated() {
    this.fetchProviders(this.fetchParams);
  },
  mounted() {
    // This will needed to be consulted. This is not ideal. But I can't easily access ref from
    // Layout component.
    // const widgetWrapper = document.getElementById('widget-wrapper');
    const appElement = document.getElementsByTagName('DISCOUNTS-WIDGET')[0];
    const widgetWrapper = appElement.shadowRoot.getElementById('widget-wrapper');
    window.onscroll = () => {
      if (this.scrollEnabled && !this.loading) {
        const widgetRect = widgetWrapper.getBoundingClientRect();
        if (widgetRect.bottom - 500 <= (window.innerHeight
            || document.documentElement.clientHeight)) {
          this.disableScroll();
          this.addProviders(this.fetchParams);
          this.enableScroll();
        }
      }
    };
  },
  beforeDestroy() {
    window.onscroll = undefined;
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  },
};
</script>
